import { html, render } from "lit-html";

export class ProgressBar extends HTMLElement {
        
    constructor() {
        super();
    }

    /* #region Public */
    public set percent(value: number){
        this._percent = value;
        this.render();
    }
    /* #endregion */
    
    static get observedAttributes() {
        return ['percent'];
    }

    /* #region Markup */
    private template = () => html`
    <style>
        .progress-bar{
            transition: width 0.3s;
        }
        </style>
        <div class="progress">
            <div class="progress-bar" role="progressbar" style="width:${this._percent}%"></div>
        </div>
        `;
    /* #endregion */
  
    /* #region Private */
    private _percent: number = 0;
    private render() {
        render(this.template(), this);
    }
    /* #endregion */
 
    /* connectedCallback */
    public connectedCallback() {
        if (this.hasAttribute("percent")) {
            this.percent = parseFloat(this.getAttribute("percent"));
        }
    }

    public attributeChangedCallback(name: any, _old: any, value: any) {       
        if (name === "percent") {
            this.percent = parseFloat(value);
        }
    }
}

/* #region Local interfaces (if they can be shared then keep in separate files) */

/* #endregion */

customElements.define("progress-bar", ProgressBar);